import { render, staticRenderFns } from "./SidebarProfile.vue?vue&type=template&id=02f4c968&scoped=true"
import script from "./SidebarProfile.vue?vue&type=script&lang=js"
export * from "./SidebarProfile.vue?vue&type=script&lang=js"
import style0 from "./SidebarProfile.vue?vue&type=style&index=0&id=02f4c968&prod&scoped=true&lang=css"
import style1 from "./SidebarProfile.vue?vue&type=style&index=1&id=02f4c968&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f4c968",
  null
  
)

export default component.exports